import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeaturedGrid from "./components/FeaturedGrid";
import DailyUpdateGrid from "./components/DailyUpdateGrid";
import ReviewSection from "./components/ReviewSection";
import CTASection from "./components/CTASection";
import { useTheme } from "@/hooks/useTheme";

export default function Home() {
  const { isDark, toggleTheme } = useTheme();

  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": "http://biensur.cn/#website",
        url: "http://biensur.cn/",
        name: "漫蛙",
        description: "漫蛙官方在线登录入口，海量免费漫画资源，热血、恋爱、悬疑、科幻等分类，支持夜间阅读模式。",
        inLanguage: "zh-Hans",
        potentialAction: {
          "@type": "SearchAction",
          target: "http://biensur.cn/search?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@type": "Organization",
        "@id": "http://biensur.cn/#organization",
        name: "漫蛙",
        url: "http://biensur.cn/",
        description: "漫蛙 - 免费在线漫画阅读平台，提供丰富的漫画资源和优质阅读体验。",
      },
      {
        "@type": "WebPage",
        "@id": "http://biensur.cn/#webpage",
        url: "http://biensur.cn/",
        name: "漫蛙 - 官方在线登录入口 - 丰富的免费漫画资源",
        isPartOf: { "@id": "http://biensur.cn/#website" },
        about: { "@id": "http://biensur.cn/#organization" },
        primaryImageOfPage: {
          "@type": "ImageObject",
          url: "https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20panoramic%20illustration%20with%20soft%20teal%20and%20warm%20orange%20gradient&width=1800&height=900&seq=hero-bg-main&orientation=landscape",
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar isDark={isDark} toggleTheme={toggleTheme} />
        <main>
          <HeroSection />
          <FeaturedGrid />
          <DailyUpdateGrid />
          <ReviewSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}